import { DeepPartial } from '../../../types';
import { ProjectSection, ProjectSectionId } from '../../domain/Project';
import { createCommand } from '../../utils';
import { moduleName, updatedProjectSection } from '../state';

interface EditProjectSectionParams {
    projectSectionId: ProjectSectionId;
    projectId: string;
    projectSectionData: DeepPartial<ProjectSection>;
}

const editProjectSection = createCommand<EditProjectSectionParams, ProjectSection>(
    `${moduleName}/EDIT_PROJECT_SECTION`,
    async ({ projectSectionData, projectSectionId, projectId }: EditProjectSectionParams, { dispatch, extra }) => {
        try {
            const projectSection = await extra.externalProject.editProjectSection(
                projectSectionId,
                projectId,
                projectSectionData,
            );
            dispatch(updatedProjectSection(projectSection));

            return projectSection;
        } catch (err) {
            // TODO: Handle errors properly
            console.error('Error editing project section:', err);
            throw err;
        }
    },
);

export default editProjectSection;
